'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bell-ring';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e62c';
var svgPathData = ['M48 384.3C48 393 55 400 63.7 400l384.6 0c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C415.5 318.1 400 274.1 400 228.6l0-36.6c0-79.5-64.5-144-144-144s-144 64.5-144 144l0 36.6c0 45.4-15.5 89.5-43.8 124.9L51.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8z', 'M256 0c-4.4 0-8 3.6-8 8l0 24 0 .2C163.4 36.4 96 106.3 96 192l0 36.6c0 41.8-14.2 82.3-40.3 114.9L38.9 364.5c-4.5 5.6-6.9 12.6-6.9 19.8C32 401.8 46.2 416 63.7 416l384.6 0c17.5 0 31.7-14.2 31.7-31.7c0-7.2-2.4-14.2-6.9-19.8l-16.7-20.9C430.2 311 416 270.4 416 228.6l0-36.6c0-85.7-67.4-155.6-152-159.8l0-.2 0-24c0-4.4-3.6-8-8-8zM112 192c0-79.5 64.5-144 144-144s144 64.5 144 144l0 36.6c0 45.4 15.5 89.5 43.8 124.9l16.7 20.9c2.2 2.8 3.4 6.2 3.4 9.8c0 8.7-7 15.7-15.7 15.7L63.7 400C55 400 48 393 48 384.3c0-3.6 1.2-7 3.4-9.8l16.7-20.9C96.5 318.1 112 274.1 112 228.6l0-36.6zm88 248c-4.4 0-8 3.6-8 8c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 12.7-5.1 24.9-14.1 33.9s-21.2 14.1-33.9 14.1s-24.9-5.1-33.9-14.1s-14.1-21.2-14.1-33.9c0-4.4-3.6-8-8-8zM100.3 21.9c3.3-3 3.5-8 .5-11.3s-8-3.5-11.3-.5C44.4 51 16 110.2 16 176c0 4.4 3.6 8 8 8s8-3.6 8-8c0-61.1 26.3-116 68.3-154.1zM422.5 10.1c-3.3-3-8.3-2.7-11.3 .5s-2.7 8.3 .6 11.3C453.7 60 480 114.9 480 176c0 4.4 3.6 8 8 8s8-3.6 8-8c0-65.8-28.4-125-73.5-165.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellRing = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;